<template #default>
  <div class="stock-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit ' + localForm.assetClass : 'Add Stock'"
      :style="{ top: '32px', width: '1500px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="addFormRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-row :gutter="24">
          <a-card
            title="Issuance Details"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Issuer"
                  name="issuer"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.issuer.issuerId"
                    @change="onIssuerChange"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in issuerList"
                      :key="item.name"
                      :value="item.issuerId"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="5">
                <a-form-item
                  label="Domicile"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.countryOfDomicile"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Risk"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.countryOfRisk"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="14">
                <a-form-item
                  label="Industry"
                  :labelCol="{ span: 2, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 22 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.gicsSubIndustry"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="5">
                <a-form-item
                  label="Inst Class"
                  name="instrumentClass"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.instrumentClass"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    :disabled="isEdit"
                  >
                    <a-select-option
                      v-for="item in eqtyInstClassList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Name"
                  name="desc"
                  :labelCol="{ span: 3, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 21 }"
                >
                  <a-input v-model:value="localForm.desc" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="BB_TCM"
                  name="ticker"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-input
                    v-model:value="localForm.ticker"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item
                  label="ISIN"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input v-model:value="localForm.isin" :disabled="isEdit" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="IssueType"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input v-model:value="localForm.issueType" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="IssueDate"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-date-picker
                    v-model:value="localForm.issueDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Issue Ccy"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-select
                    v-model:value="localForm.issueCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="Par Value"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number
                    v-model:value="localForm.parValue"
                    style="width: 100%"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="PnL Ccy"
                  name="pnlCurrency"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.pnlCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Sec Type"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <SecTypeInput v-model:value="localForm.securityType" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Orig Issue Amt"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Amt Curr In Issue"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Max Issue Amt"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="Effective From"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Effective To"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card
            title="Security Details"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="SecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input
                    v-model:value="localForm.securityId"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="ExternalSecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.externalSecurityId"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Sec Effv From"
                  v-if="isEdit"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Sec Effv To"
                  v-if="isEdit"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Exchange"
                  name="exchange"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.exchange.exchangeId"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in exchangeList"
                      :key="item.exchName"
                      :value="item.exchangeId"
                    >
                      {{ item.exchName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Price Multiplier"
                  name="priceMultiplier"
                  :labelCol="{ span: 13, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 11 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceMultiplier"
                    style="width: 100%"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Price Divisor"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceDivisor"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Round Lot Size"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-input-number
                    v-model:value="localForm.lotSize"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="FTT Eligible"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.isActive"
                    style="width: 100%"
                    disabled
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Pricing Market"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Primary Market"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option :value="P">P</a-select-option>
                    <a-select-option :value="N">N</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="List Date"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    v-model:value="localForm.ipoDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Launch Date"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="FAS 157 valuation"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option :value="Level1">Level1</a-select-option>
                    <a-select-option :value="Level2">Level2</a-select-option>
                    <a-select-option :value="Level3">Level3</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Maturity Date"
                  name="maturityDate"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    v-model:value="localForm.maturityDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Is 144"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option :value="N">N</a-select-option>
                    <a-select-option :value="R">R</a-select-option>
                    <a-select-option :value="Y">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item label="Is RegS">
                  <a-select
                    style="width: 100%"
                    v-model:value="localForm.isRegS"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <!-- <a-select-option :value="R">R</a-select-option> -->
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item label="Series">
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Market Listing Type"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select style="width: 100%">
                    <a-select-option :value="A">A Shares-China</a-select-option>
                    <a-select-option :value="B">B Shares-China</a-select-option>
                    <a-select-option :value="'*'">All</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Dividend Ccy"
                  name="dividendCurrency"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.dividendCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Dividend/PnL Ccy Xrate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-row>
                    <a-col :span="12">
                      <a-input-number
                        v-model:value="localForm.fixedRate"
                        style="width: 100%"
                        :disabled="isEdit"
                      />
                    </a-col>
                    <a-col :span="12">
                      <a-select
                        style="width: 100%"
                        v-model:value="localForm.fixedRateMdInd"
                        :disabled="isEdit"
                      >
                        <a-select-option :value="M">M</a-select-option>
                        <a-select-option :value="D">D</a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Status"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.isActive"
                    style="width: 100%"
                  >
                    <a-select-option :value="true">ACTIVE</a-select-option>
                    <a-select-option :value="false">INACTIVE</a-select-option>
                    <!-- <a-select-option :value="Active">Active</a-select-option>
                    <a-select-option :value="Delisted"
                      >Delisted</a-select-option
                    >
                    <a-select-option :value="Funged">Funged</a-select-option>
                    <a-select-option :value="Inactive"
                      >Inactive</a-select-option
                    >
                    <a-select-option :value="Registing"
                      >Registing</a-select-option
                    > -->
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="External Type"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card
            v-if="
              localForm.instrumentClass === 'DR' ||
              localForm.instrumentClass === 'RIGHTS' ||
              localForm.instrumentClass === 'WRNT'
            "
            title="Underlying"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Ticker"
                  name="underlyingTicker"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-auto-complete
                    v-model:value="localForm.underlyingTicker"
                    :disabled="isEdit"
                    :options="underlyingOptions"
                    @search="onSearchUnderlying"
                    @select="onSelectUnderlying"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Exchange"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-select
                    v-model:value="localForm.underlying.exchange.exchangeId"
                    disabled
                  >
                    <a-select-option
                      v-for="item in exchangeList"
                      :key="item.exchName"
                      :value="item.exchangeId"
                    >
                      {{ item.exchName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Dividend Ccy"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.underlying.principalCcyCode"
                    disabled
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  v-if="
                    localForm.instrumentClass === 'DR' ||
                    localForm.instrumentClass === 'WRNT'
                  "
                  label="Ratio(shares/DR)"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.conversionRatio"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="localForm.instrumentClass === 'WRNT'">
              <a-col :span="4">
                <a-form-item
                  label="Call Put"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.callPut"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in callPutList"
                      :key="item.desc"
                      :value="item.code"
                    >
                      {{ item.desc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Settlement Type"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select v-model:value="localForm.settlementType">
                    <a-select-option
                      v-for="item in settlementTypeList"
                      :key="item.desc"
                      :value="item.code"
                    >
                      {{ item.desc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Exercise Style"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.exerciseStyle"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in exerciseStyleList"
                      :key="item.desc"
                      :value="item.code"
                    >
                      {{ item.desc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Exercise Price Currency"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select
                    v-model:value="localForm.exercisePriceCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Exercise Price"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.exercisePrice"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="localForm.instrumentClass === 'WRNT'">
              <a-col :span="6">
                <a-form-item
                  label="Exercise Price Multiplier"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-input-number
                    v-model:value="localForm.exercisePriceMultiplier"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="First Exercise Date"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    v-model:value="localForm.firstExerciseDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  defineProps,
  defineEmits,
  inject,
  // watchEffect,
  watch,
} from 'vue'
import { useStore } from 'vuex'
import SecTypeInput from '@/components/SecTypeInput.vue'
import debounce from 'lodash/debounce'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'

const store = useStore()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  addForm: {
    type: Object,
    required: true,
  },
})

const labelCol = {
  span: 8,
  style: { textAlign: 'left' },
}

const wrapperCol = {
  span: 18,
}

const exchangeList = inject('exchangeList', ref([]))
const issuerList = inject('issuerList', ref([]))
const eqtyInstClassList = inject('eqtyInstClassList', ref([]))
const security = inject('security')

const currencyList = computed(() => {
  const currencies = store.getters['reference/getCurrencyList'] || []
  return [...currencies].sort((a, b) =>
    a.currencyCode.localeCompare(b.currencyCode)
  )
})
const countryCurrencyList = computed(() => {
  return store.getters['reference/getCountryCurrencyList'] || []
})

const underlyingOptions = ref([])
const tickerList = ref([])
const addFormRef = ref()
const loading = ref(false)
const localForm = ref(props.addForm)

// set only when the user picks an issuer from the dropdown, so the currency
// defaults below never overwrite values loaded from getSecurity
const isIssuerSelectedByUser = ref(false)
const onIssuerChange = () => {
  isIssuerSelectedByUser.value = true
}
const rules = ref({
  instrumentClass: [
    { required: true, message: 'Please input instrumentClass' },
  ],
  desc: [{ required: true, message: 'Please input name' }],
  ticker: [{ required: true, message: 'Please input BB_TCM' }],
  issuer: [{ required: true, message: 'Please select issuer' }],
  issueCurrency: [{ required: true, message: 'Please select issue ccy' }],
  pnlCurrency: [{ required: true, message: 'Please select pnl ccy' }],
  exchange: [{ required: true, message: 'Please select exchange' }],
  priceMultiplier: [
    { required: true, message: 'Please input priceMultiplier' },
  ],
  maturityDate: [{ required: false, message: 'Please input maturity date' }],
  dividendCurrency: [{ required: true, message: 'Please select dividend ccy' }],
  underlyingTicker: [
    {
      required: localForm.value.instrumentClass === 'DR' || 'RIGHTS',
      message: 'Please select underlying',
    },
  ],
})
const callPutList = [
  { code: 'C', desc: 'CALL' },
  { code: 'P', desc: 'PUT' },
]
const exerciseStyleList = [
  { code: 'E', desc: 'EUROPEAN' },
  { code: 'A', desc: 'AMERICAN' },
]
const settlementTypeList = [
  { code: 'C', desc: 'CASH' },
  { code: 'P', desc: 'PHYSICAL' },
]

const emit = defineEmits(['update:visible', 'update:security'])

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const userName = computed(() => store.getters['auth/getUserName'] || 'Guest')

const onSelectUnderlying = async (value) => {
  localForm.value.underlyingTicker = value
  const res = await security.getSecurityStartWith({
    ticker: value,
  })
  const underlying = res.data[0]
  underlying.pnlCurrency = underlying.pnlCcyCode
  const selectedUnderlyingExchange = exchangeList.value.find(
    (item) => item.exchName === underlying.exchangeCode
  )
  if (selectedUnderlyingExchange) {
    underlying.exchange = {
      exchangeId: selectedUnderlyingExchange.exchangeId,
      exchName: selectedUnderlyingExchange.exchName,
    }
  }
  const selectedUnderlyingIssuer = issuerList.value.find(
    (item) => item.name === underlying.issuerCode
  )
  if (selectedUnderlyingIssuer) {
    underlying.issuer = {
      issuerId: selectedUnderlyingIssuer.issuerId,
      externalIssuerId: selectedUnderlyingIssuer.externalIssuerId,
      name: selectedUnderlyingIssuer.name,
      countryOfDomicile: selectedUnderlyingIssuer.countryOfDomicile,
    }
  }
  localForm.value.underlying = underlying
}

watch(
  () => props.addForm,
  (newVal) => {
    isIssuerSelectedByUser.value = false
    if (props.visible) {
      localForm.value = newVal
      if (props.isEdit && localForm.value.underlyingTicker) {
        onSelectUnderlying(localForm.value.underlyingTicker)
      }
      if (!newVal.underlying) {
        if (localForm.value.instrumentClass !== 'ORD') {
          localForm.value.underlying = {
            exchange: {
              exchangeId: null,
              exchName: null,
              micExchName: null,
            },
          }
        }
      } else if (!newVal.underlying.exchange) {
        localForm.value.underlying = {
          ...newVal.underlying,
          exchange: {
            exchangeId: null,
            exchName: null,
            micExchName: null,
          },
        }
      }
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => localForm.value.instrumentClass,
  (newValue) => {
    rules.value = {
      ...rules.value,
      maturityDate: [
        {
          required: newValue === 'WRNT',
          message: 'Please select maturity date',
        },
      ],
      underlyingTicker: [
        {
          required: newValue === 'DR' || 'RIGHTS' || 'WRNT',
          message: 'Please select underlying',
        },
      ],
    }
  },
  { immediate: true }
)
watch(
  () => localForm.value.priceDivisor,
  (newValue) => {
    if (newValue) {
      localForm.value.priceDivisor = newValue
      localForm.value.priceMultiplier = 1 / newValue
    }
  },
  { immediate: true }
)
watch(
  () => localForm.value.issuer?.issuerId,
  (newValue) => {
    if (newValue) {
      const selectedIssuer = issuerList.value.find(
        (item) => item.issuerId === newValue
      )
      if (selectedIssuer) {
        localForm.value.issuer = {
          issuerId: selectedIssuer.issuerId,
          externalIssuerId: selectedIssuer.externalIssuerId,
          name: selectedIssuer.name,
          countryOfDomicile: selectedIssuer.countryOfDomicile,
        }
        const selectedCurrency = countryCurrencyList.value.find(
          (item) => item.countryCode === selectedIssuer.countryOfDomicile
        )
        if (selectedCurrency && isIssuerSelectedByUser.value) {
          localForm.value.issueCurrency = selectedCurrency.currencyCode
          localForm.value.pnlCurrency = selectedCurrency.currencyCode
          localForm.value.dividendCurrency = selectedCurrency.currencyCode
        }
      }
    }
  },
  { immediate: true }
)

const filterOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const searchUnderlying = (ticker) => {
  if (!ticker || ticker.length < 3) {
    return
  }
  security.getSecurityStartWith({ ticker }).then((res) => {
    tickerList.value = res.data
    const underlyingTickers = res.data
      .filter((item) => item.ticker)
      .map((item) => item.ticker)
    underlyingTickers.sort((a, b) => b.localeCompare(a))
    const arr =
      underlyingTickers.length > 8
        ? underlyingTickers.slice(0, 8)
        : underlyingTickers
    underlyingOptions.value = arr.map((item) => ({ value: item }))
  })
}
const onSearchUnderlying = debounce(
  function (underlyingTicker) {
    searchUnderlying(underlyingTicker)
  },
  600,
  { maxWait: 1000 }
)

const handleOk = () => {
  addFormRef.value
    .validate()
    .then(() => {
      const formatDateTime = (val) =>
        val ? dayjs(val).format('YYYY-MM-DDTHH:mm:ss') : null

      const lastModifiedOn = dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ss')
      const lastModifiedBy = userName.value

      let payload = {
        ...localForm.value,
        name: localForm.value.desc,
        exchange: { ...localForm.value.exchange },
        issuer: { ...localForm.value.issuer },
        identifiers: [],
        underlying: localForm.value.underlying
          ? { ...localForm.value.underlying }
          : null,
        issueDate: formatDateTime(localForm.value.issueDate),
        maturityDate: formatDateTime(localForm.value.maturityDate),
        settleDate: formatDateTime(localForm.value.settleDate),
        lastModifiedOn: lastModifiedOn,
        lastModifiedBy: lastModifiedBy,
      }

      if (payload.ticker) {
        payload.identifiers.push({
          type: 'BB_TCM',
          value: payload.ticker,
        })
      }
      if (payload.isin) {
        payload.identifiers.push({
          type: 'ISIN',
          value: payload.isin,
        })
      }
      const selectedExchange = exchangeList.value.find(
        (item) => item.exchangeId === payload.exchange.exchangeId
      )
      if (selectedExchange) {
        payload.exchange = {
          exchangeId: selectedExchange.exchangeId,
          exchName: selectedExchange.exchName,
          micExchName: selectedExchange.micExchName,
        }
      }

      const underlyingIdentifiers = []
      if (payload.underlyingTicker) {
        underlyingIdentifiers.push({
          type: 'BB_TCM',
          value: payload.underlyingTicker,
          securityId: payload.underlying.securityId,
          pnlCurrency: payload.underlying.pnlCurrency,
        })
        if (!payload.underlying) payload.underlying = {}
        payload.underlying.identifiers = underlyingIdentifiers
        payload.underlying.instrumentClass = 'DUMMY'
      }

      loading.value = true
      if (props.isEdit) {
        security
          .updateSec(payload)
          .then(() => {
            message.success('Security updated successfully')
            modalVisible.value = false
          })
          .catch((error) => {
            message.error(
              error.response.data.message || 'Failed to update security'
            )
          })
          .finally(() => {
            loading.value = false
          })
      } else {
        security
          .createSec(payload)
          .then(() => {
            message.success('Security created successfully')
            modalVisible.value = false
          })
          .catch((error) => {
            message.error(
              error.response.data.message || 'Failed to create security'
            )
          })
          .finally(() => {
            loading.value = false
          })
      }
    })
    .catch((error) => {
      console.log('error', error)
    })
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>

<style scoped>
.stock-modal :deep(.ant-card) {
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
}
.stock-modal :deep(.ant-card-head-title) {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.stock-modal :deep(.ant-card-body) {
  padding-top: 8px;
}
</style>
